/* =====================================================================
   DEAD COTTON — Script du site (porté de assets/app.js du prototype, 2026-10-11)
   En-tête collant, tiroir menu, diaporama du hero, carrousels, cartes produit
   (pastilles de couleur, « Ajouter » → vrai panier Shopify), sous-titres sur une ligne.
   Toutes les classes d'état sont préfixées dc- (dc-is-open, dc-is-active, dc-is-stuck).
   ===================================================================== */
(function () {
  "use strict";

  /* ---------- En-tête collant : fond crème + ombre dès qu'on scrolle ---------- */
  var header = document.querySelector(".dc-header");
  if (header) {
    var onScroll = function () { header.classList.toggle("dc-is-stuck", window.scrollY > 8); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Tiroir menu ---------- */
  var overlay = document.querySelector("[data-dc-overlay]");
  var menuDrawer = document.querySelector("[data-dc-drawer='menu']");
  function openMenu() {
    if (!menuDrawer) return;
    menuDrawer.classList.add("dc-is-open");
    overlay && overlay.classList.add("dc-is-open");
    document.body.style.overflow = "hidden";
  }
  function closeMenu() {
    document.querySelectorAll(".dc-drawer").forEach(function (d) { d.classList.remove("dc-is-open"); });
    overlay && overlay.classList.remove("dc-is-open");
    document.body.style.overflow = "";
  }
  overlay && overlay.addEventListener("click", closeMenu);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });
  document.querySelectorAll("[data-dc-close-drawer]").forEach(function (b) { b.addEventListener("click", closeMenu); });
  document.querySelectorAll("[data-dc-open-menu]").forEach(function (b) { b.addEventListener("click", openMenu); });

  /* ---------- Diaporama du hero (5 s, fondu ; rideau au doigt) ---------- */
  (function initHero() {
    var wrap = document.querySelector("[data-dc-hero-slides]");
    if (!wrap) return;
    var slides = Array.prototype.slice.call(wrap.querySelectorAll(".dc-hero__slide"));
    if (slides.length < 2) { slides[0] && slides[0].classList.add("dc-is-active"); return; }

    var dotsBox = document.querySelector("[data-dc-hero-dots]");
    var hero = wrap.closest("section") || wrap;
    var dots = slides.map(function (_, n) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "Slide " + (n + 1));
      b.addEventListener("click", function () { go(n); restart(); });
      dotsBox && dotsBox.appendChild(b);
      return b;
    });

    /* Défilement automatique et pastilles : FONDU (0,8 s, comme deadcotton.fr), partout.
       Glissement du doigt (2026-10-17) : effet « rideau » (façon cruelpancake.com) — la slide suit le doigt et RECOUVRE l'ancienne, qui recule de 30 % derrière,
       ombre sur son bord ; elle termine seule si le geste est assez long / rapide, sinon revient. Pointeurs tactiles / stylet seulement (pas la souris). */
    var DUR = 800, BACK = 0.3, i = 0, timer = null, busy = false, suppress = false, fadeUntil = 0;
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };   // easeOutCubic : le mouvement repart à la vitesse du doigt puis ralentit (un départ en douceur donnait un « arrêt puis redémarrage » au relâchement)

    function setDot(n) { dots.forEach(function (d, k) { d.classList.toggle("dc-is-active", k === n); }); }
    function place(out, inn, p, dir) {   // p = avancement 0..1 ; dir = +1 (suivante, arrive par la droite) / -1 (précédente, arrive par la gauche)
      out.style.transform = "translate3d(" + (-dir * p * BACK * 100) + "%,0,0)";
      inn.style.transform = "translate3d(" + (dir * (1 - p) * 100) + "%,0,0)";
    }
    function prepare(out, inn, dir) {
      out.classList.add("dc-is-moving");
      inn.classList.add("dc-is-moving", "dc-is-in");
      inn.classList.toggle("dc-from-left", dir < 0);
    }
    function reset(s) {   // remet une slide au repos SANS fondu résiduel (transition coupée le temps du retour à la position d'origine)
      s.style.transition = "none"; s.style.transform = "";
      s.classList.remove("dc-is-moving", "dc-is-in", "dc-from-left");
      return s;
    }
    function settle(list) { void list[0].offsetWidth; list.forEach(function (s) { s.style.transition = ""; }); }
    function commit(n) {
      var old = reset(slides[i]); old.classList.remove("dc-is-active");
      var nw = reset(slides[n]); nw.classList.add("dc-is-active");
      settle([old, nw]);
      i = n; setDot(n); busy = false;
    }
    function abort(n) { settle([reset(slides[n]), reset(slides[i])]); busy = false; }
    function tween(from, to, ms, step, done) {
      var t0 = performance.now();
      (function frame(now) {
        var k = Math.min(1, (now - t0) / ms), v = from + (to - from) * ease(k);
        step(v);
        if (k < 1) requestAnimationFrame(frame); else done();
      })(t0);
    }
    function go(n) {   // fondu : automatique et pastilles
      n = (n + slides.length) % slides.length;
      if (n === i || busy) return;
      slides[i].classList.remove("dc-is-active"); slides[n].classList.add("dc-is-active");
      i = n; setDot(n); fadeUntil = performance.now() + DUR;
    }
    slides[0].classList.add("dc-is-active"); setDot(0);
    function restart() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 5000); }   // même cadence que deadcotton.fr
    restart();

    /* Glissement au doigt : touch-action: pan-y laisse le défilement vertical au navigateur. */
    hero.style.touchAction = "pan-y";
    var drag = null;
    function target(dir) { return slides[(i + dir + slides.length) % slides.length]; }
    hero.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" || busy || !e.isPrimary || performance.now() < fadeUntil) return;
      drag = { x: e.clientX, y: e.clientY, t: performance.now(), on: false, dir: 0, p: 0 };
    });
    hero.addEventListener("pointermove", function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.on) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;
        drag.on = true; clearInterval(timer);
      }
      var dir = dx < 0 ? 1 : -1, w = wrap.clientWidth || 1;
      if (dir !== drag.dir) {
        if (drag.dir) { var prev = target(drag.dir); settle([reset(prev)]); }
        drag.dir = dir; prepare(slides[i], target(dir), dir);
      }
      drag.p = Math.min(1, Math.abs(dx) / w);
      place(slides[i], target(dir), drag.p, dir);
    });
    function endDrag(e, cancelled) {
      if (!drag) return;
      var d = drag; drag = null;
      if (!d.on) return;
      suppress = true; setTimeout(function () { suppress = false; }, 60);
      var n = (i + d.dir + slides.length) % slides.length, out = slides[i], inn = slides[n];
      var dx = e.clientX - d.x, speed = Math.abs(dx) / Math.max(1, performance.now() - d.t);   // px / ms
      var go_on = !cancelled && (d.p > 0.25 || (speed > 0.5 && Math.abs(dx) > 30));
      busy = true;
      if (go_on) { setDot(n); tween(d.p, 1, 180 + 420 * (1 - d.p), function (p) { place(out, inn, p, d.dir); }, function () { commit(n); restart(); }); }
      else tween(d.p, 0, 180 + 420 * d.p, function (p) { place(out, inn, p, d.dir); }, function () { abort(n); restart(); });
    }
    hero.addEventListener("pointerup", function (e) { endDrag(e, false); });
    hero.addEventListener("pointercancel", function (e) { endDrag(e, true); });
    hero.addEventListener("click", function (e) { if (suppress) { e.preventDefault(); e.stopPropagation(); } }, true);
  })();

  /* ---------- Carrousels (flèches) ---------- */
  document.querySelectorAll("[data-dc-carousel-track]").forEach(function (track) {
    var scope = track.closest("section") || track.parentElement;
    var prev = scope.querySelector("[data-dc-carousel-prev]");
    var next = scope.querySelector("[data-dc-carousel-next]");
    var step = function () { return Math.min(track.clientWidth * 0.8, 520); };
    var update = function () {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    };
    prev && prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    next && next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });

  /* ---------- Cartes produit : pastille de couleur ---------- */
  function parse(el, name) { try { return JSON.parse(el.getAttribute(name) || "{}"); } catch (e) { return {}; } }
  document.addEventListener("click", function (e) {
    var sw = e.target.closest(".dc-card__swatches .dc-swatch");
    if (!sw) return;
    var card = sw.closest(".dc-card");
    if (!card) return;
    card.querySelectorAll(".dc-swatch").forEach(function (s) { s.classList.toggle("dc-is-active", s === sw); });
    var colors = parse(card, "data-colors");
    var c = colors[sw.dataset.color];
    var imgs = card.querySelectorAll(".dc-card__link img");
    if (c && imgs[0] && c.main) { imgs[0].src = c.main; imgs[0].removeAttribute("srcset"); }
    if (c && imgs[1] && c.hover) { imgs[1].src = c.hover; imgs[1].removeAttribute("srcset"); }
    if (c && c.url) card.querySelectorAll(".dc-card__link, .dc-card__title").forEach(function (a) { a.href = c.url; });
  });

  /* ---------- Cartes produit : « Ajouter » → panier Shopify (taille M par défaut, comme le prototype) ---------- */
  function refreshCartBubble() {
    return fetch("/?sections=cart-icon-bubble").then(function (r) { return r.json(); }).then(function (data) {
      var html = data["cart-icon-bubble"];
      var target = document.querySelector("#cart-icon-bubble");
      if (!html || !target) return;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var sec = doc.querySelector(".shopify-section");
      target.innerHTML = sec ? sec.innerHTML : html;
    });
  }
  document.addEventListener("click", function (e) {
    var add = e.target.closest("[data-dc-add]");
    if (!add) return;
    e.preventDefault();
    var card = add.closest(".dc-card");
    if (!card) return;
    var variants = parse(card, "data-variants");
    var active = card.querySelector(".dc-swatch.dc-is-active");
    var color = active ? active.dataset.color : "";
    var id = variants[color + "|M"] || variants[color + "|"] || Object.keys(variants).filter(function (k) { return k.indexOf(color + "|") === 0; }).map(function (k) { return variants[k]; })[0];
    if (!id) return;   // carte de démo (pas de vrai produit derrière)
    var label = add.textContent;
    add.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error("add"); return window.dcOpenCart ? window.dcOpenCart() : refreshCartBubble(); })   // tiroir panier (dc-cart-drawer.js) : recharge + ouvre
      .catch(function () {
        // Shopify refuse (variante épuisée…) : on le dit au lieu de ne rien faire
        if (label.trim()) { add.textContent = "Indisponible"; setTimeout(function () { add.textContent = label; }, 2000); }
      })
      .then(function () { add.disabled = false; });
  });

  /* ---------- Page collection : filtre par type + bouton « Type » (mobile) ---------- */
  (function initCollection() {
    var root = document.querySelector("[data-dc-collection]");
    if (!root) return;
    var toggle = root.querySelector("[data-dc-toggle-type]");
    var aside = root.querySelector(".dc-collection__filters");
    if (toggle && aside) {
      toggle.addEventListener("click", function () {
        var open = aside.classList.toggle("dc-is-open");
        toggle.setAttribute("aria-expanded", String(open));
        toggle.classList.toggle("dc-is-active", open);
      });
    }
    var buttons = root.querySelectorAll("[data-dc-filter-type]");
    var cards = root.querySelectorAll(".dc-collection__grid .dc-card");
    var empty = root.querySelector("[data-dc-collection-empty]");
    var defaultEmpty = empty ? empty.textContent : "";
    // Types sans produit dans cette édition : cases masquées ; un seul type = plus de filtre du tout (comme le prototype, 2026-10-16).
    var typesHere = {}, nbTypes = 0;
    cards.forEach(function (c) { if (c.dataset.type && !typesHere[c.dataset.type]) { typesHere[c.dataset.type] = true; nbTypes++; } });
    buttons.forEach(function (btn) { if (btn.dataset.dcFilterType !== "all") btn.hidden = !typesHere[btn.dataset.dcFilterType]; });
    if (nbTypes <= 1) {
      if (aside) aside.hidden = true;
      if (toggle) toggle.hidden = true;
    }
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        buttons.forEach(function (b) { b.classList.remove("dc-is-active"); });
        btn.classList.add("dc-is-active");
        var type = btn.dataset.dcFilterType;
        var shown = 0;
        cards.forEach(function (c) {
          var ok = type === "all" || c.dataset.type === type;
          c.hidden = !ok;
          if (ok) shown++;
        });
        if (empty) {
          empty.hidden = shown > 0;
          empty.textContent = type === "all" ? defaultEmpty : btn.dataset.label + " — bientôt disponibles dans cette édition.";
        }
      });
    });
  })();

  /* ---------- Sous-titres d'une phrase : une seule ligne en mobile (taille ajustée) ---------- */
  function fitLine(el) {
    var mobile = window.matchMedia(el.closest(".dc-usp") ? "(max-width: 560px)" : "(max-width: 900px)").matches;
    el.style.fontSize = "";
    el.style.whiteSpace = "";
    if (!mobile) return;
    var avail = el.clientWidth;
    el.style.whiteSpace = "nowrap";
    var base = parseFloat(getComputedStyle(el).fontSize);
    var need = el.scrollWidth;
    if (need <= avail) return;
    var size = Math.floor(base * (avail / need) * 100 * 0.99) / 100;
    if (size < 11) { el.style.whiteSpace = ""; return; }
    el.style.fontSize = size + "px";
  }
  var fitEls = document.querySelectorAll(".dc-section-head p, .dc-collection__head p, .dc-usp__item p, .dc-split__tile p");
  var fitAll = function () { fitEls.forEach(fitLine); };
  window.addEventListener("resize", fitAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  fitAll();
})();


/* 2026-10-18 — pastilles vertes « impact » de la fiche produit : un clic affiche / masque la précision (identique au prototype). */
(function () {
  function closeAll(box) {
    box.querySelectorAll(".dc-eco__pill").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    var n = box.querySelector(".dc-eco__note"); if (n) n.hidden = true;
  }
  document.addEventListener("click", function (e) {
    var pill = e.target.closest(".dc-eco__pill");
    document.querySelectorAll("[data-dc-eco]").forEach(function (box) {
      var note = box.querySelector(".dc-eco__note");
      if (pill && box.contains(pill)) {
        var same = pill.getAttribute("aria-expanded") === "true";
        box.querySelectorAll(".dc-eco__pill").forEach(function (b) { b.setAttribute("aria-expanded", String(!same && b === pill)); });
        note.hidden = same;
      } else if (!e.target.closest(".dc-eco__note")) {
        closeAll(box);
      }
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") document.querySelectorAll("[data-dc-eco]").forEach(closeAll);
  });
})();
